import React from 'react';
import PropTypes from 'prop-types';
import { cardProviders } from '../../../../../screens/Card/constants';

const MAPPING = {
  [cardProviders.MONAVATE]: (
    <svg x={110} y={157} width="14" height="6" viewBox="0 0 14 6" fill="none">
      <path
        d="M2.28235 5.65055C3.43497 5.65055 4.18303 4.80326 4.20593 3.4598H3.36627C3.36627 4.59716 3.21361 4.91012 2.36631 4.91012H2.21365C1.50375 4.91012 1.16026 4.67349 1.16026 3.6201V2.18505C1.16026 1.13165 1.50375 0.895022 2.21365 0.895022H2.36631C3.21361 0.895022 3.36627 1.20799 3.36627 2.34534H4.20593C4.18303 1.00189 3.44261 0.154595 2.28235 0.154595C1.04576 0.154595 0.305331 1.14692 0.305331 2.90257C0.305331 4.65823 1.04576 5.65055 2.28235 5.65055ZM4.80598 0.230927L6.3021 5.57422H7.38603L8.92795 0.230927H8.13409L6.90513 4.70403H6.79826L5.62274 0.230927H4.80598ZM9.38296 0.230927L10.8791 5.57422H11.963L13.5049 0.230927H12.7111L11.4821 4.70403H11.3752L10.1997 0.230927H9.38296Z"
        fill="#2D2926"
      />
    </svg>
  ),
  [cardProviders.GALILEO]: (
    <svg x={110} y={160} width="14" height="9" viewBox="0 0 14 6" fill="none">
      <path
        d="M2.28235 5.65055C3.43497 5.65055 4.18303 4.80326 4.20593 3.4598H3.36627C3.36627 4.59716 3.21361 4.91012 2.36631 4.91012H2.21365C1.50375 4.91012 1.16026 4.67349 1.16026 3.6201V2.18505C1.16026 1.13165 1.50375 0.895022 2.21365 0.895022H2.36631C3.21361 0.895022 3.36627 1.20799 3.36627 2.34534H4.20593C4.18303 1.00189 3.44261 0.154595 2.28235 0.154595C1.04576 0.154595 0.305331 1.14692 0.305331 2.90257C0.305331 4.65823 1.04576 5.65055 2.28235 5.65055ZM4.80598 0.230927L6.3021 5.57422H7.38603L8.92795 0.230927H8.13409L6.90513 4.70403H6.79826L5.62274 0.230927H4.80598ZM9.38296 0.230927L10.8791 5.57422H11.963L13.5049 0.230927H12.7111L11.4821 4.70403H11.3752L10.1997 0.230927H9.38296Z"
        fill="#2D2926"
      />
    </svg>
  ),
};

export const CVVLabel = ({ cardProvider = null }) => MAPPING[cardProvider] || null;
export default CVVLabel;

CVVLabel.propTypes = {
  cardProvider: PropTypes.string,
};
